<template>
    <div class="policy-content" v-html="htmlContent"></div>
</template>

<script>
export default {
    data() {
        return {
            htmlContent: ''
        }
    },
    mounted() {
        fetch('/igs-lms-privacy-policy.html')
            .then(res => res.text())
            .then(html => {
                this.htmlContent = html
            })
            .catch(err => {
                console.error('Failed to load HTML:', err)
            })
    }
}
</script>

<style scoped>
.policy-content {
    background-color: white;
    margin: 40px auto;
    padding: 24px;
    line-height: 1.6;
    font-size: 11px;
    font-family: Arial;
    height: 85vh;
    width: 100%;
    max-width: 800px;
    color: black;
    overflow-y: auto;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
</style>
